import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { CanvasContext } from "../../../contexts/CanvasContext";

const ColorInputComponent = ({ colorInput = {} }) => {
  const { hoveredDivision, files } = useContext(CanvasContext);

  const isHovered = colorInput.id === hoveredDivision;
  const [isDivHovered, setIsDivHovered] = useState(false);
  const [isDivFocused, setIsDivFocused] = useState(false);
  const [isDivActive, setIsDivActive] = useState(false);
  const [backgroundImagelabelUrl, setlabelbackgroundImagelabelUrl] =
    useState(null);

  const labelconstructGradientString = () => {
    const {
      labelbackgroundGradientImage,
      labelgradientDirection,
      labelgradientShape,
      labelgradientPosition,
      labelstartColor,
      labelendColor,
      labelgradientAngle,
      labelpatternLength,
    } = colorInput;

    switch (labelbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${labelgradientDirection || "to right"}, ${
          labelstartColor || "#ff7e5f"
        }, ${labelendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${labelgradientShape || "circle"} at ${
          labelgradientPosition || "center"
        }, ${labelstartColor || "#ff7e5f"}, ${labelendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${labelgradientAngle || "45"}deg, ${
          labelstartColor || "#606dbc"
        }, ${labelendColor || "#465298"} ${labelpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          labelgradientShape || "circle"
        } at ${labelgradientPosition || "center"}, ${
          labelstartColor || "#ff7e5f"
        }, ${labelendColor || "#feb47b"} ${labelpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };


  useEffect(() => {
    const fetchlabelbackgroundImagelabel = async () => {
      if (
        colorInput.labelbackgroundImagelabel &&
        colorInput.labelbackgroundImagelabel.startsWith("./")
      ) {
        const imageName = colorInput.labelbackgroundImagelabel.replace(
          "./",
          ""
        );
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setlabelbackgroundImagelabelUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setlabelbackgroundImagelabelUrl(colorInput.labelbackgroundImagelabel);
      }
    };

    fetchlabelbackgroundImagelabel();
  }, [colorInput.labelbackgroundImagelabel, files]);

  const focusedStyles =
    isDivFocused && colorInput.pseudoClass === "focus"
      ? {
          // width: colorInput.focusedwidth || colorInput.width || "200px",
          // height: colorInput.focusedheight || colorInput.height || "auto",

          padding: colorInput.focusedpadding || colorInput.padding || "0",
          paddingTop:
            colorInput.focusedpaddingTop || colorInput.focusedpadding || "4px",
          paddingRight:
            colorInput.focusedpaddingRight || colorInput.focusedpadding || "4px",
          paddingBottom:
            colorInput.focusedpaddingBottom || colorInput.focusedpadding || "4px",
          paddingLeft:
            colorInput.focusedpaddingLeft || colorInput.focusedpadding || "4px",
          margin: colorInput.focusedmargin || colorInput.margin || "0px",
          marginTop:
            colorInput.focusedmarginTop || colorInput.focusedmargin || "0px",
          marginRight:
            colorInput.focusedmarginRight || colorInput.focusedmargin || "0px",
          marginBottom:
            colorInput.focusedmarginBottom || colorInput.focusedmargin || "0px",
          marginLeft:
            colorInput.focusedmarginLeft || colorInput.focusedmargin || "10px",

          borderTop:
            colorInput.focusedborderTop ||
            colorInput.focusedborder ||
            colorInput.border ||
            "1px solid #000000",
          borderRight:
            colorInput.focusedborderRight ||
            colorInput.focusedborder ||
            colorInput.border ||
            "1px solid #000000",
          borderBottom:
            colorInput.focusedborderBottom ||
            colorInput.focusedborder ||
            colorInput.border ||
            "1px solid #000000",
          borderLeft:
            colorInput.focusedborderLeft ||
            colorInput.focusedborder ||
            colorInput.border ||
            "1px solid #000000",
          borderSapcing:
            colorInput.focusedborderSpacing ||
            colorInput.borderSpacing ||
            "0px",
          borderCollapse:
            colorInput.focusedborderCollapse ||
            colorInput.borderCollapse ||
            "0px",
          borderRadius:
            colorInput.focusedborderRadius || colorInput.borderRadius || "0",
          outline: colorInput.focusedoutline || colorInput.outline || "none",

          position:
            colorInput.focusedposition || colorInput.position || "relative",
          top: colorInput.focusedtop || colorInput.top || "auto",
          right: colorInput.focusedright || colorInput.right || "auto",
          bottom: colorInput.focusedbottom || colorInput.bottom || "auto",
          left: colorInput.focusedleft || colorInput.left || "auto",
          zIndex: colorInput.focusedzIndex || colorInput.zIndex || "auto",

          boxShadow:
            colorInput.focusedboxShadow || colorInput.boxShadow || "none",
          opacity: colorInput.focusedOpacity || colorInput.opacity || 1,
          display: colorInput.focuseddisplay || colorInput.display || "inline",

          cursor: colorInput.focusedcursor || colorInput.cursor || "default",
          transform:
            colorInput.focusedtransform || colorInput.transform || "none",
          transition:
            colorInput.focusedtransition || colorInput.transition || "none",
        }
      : {};
  const hoverStyles =
    isDivHovered && colorInput.pseudoClass === "hover"
      ? {
          // width: colorInput.hoveredwidth || colorInput.width || "200px",
          // height: colorInput.hoveredheight || colorInput.height || "auto",

          padding: colorInput.hoveredpadding || colorInput.padding || "0",
          paddingTop:
            colorInput.hoveredpaddingTop || colorInput.hoveredpadding || "4px",
          paddingRight:
            colorInput.hoveredpaddingRight || colorInput.hoveredpadding || "4px",
          paddingBottom:
            colorInput.hoveredpaddingBottom || colorInput.hoveredpadding || "4px",
          paddingLeft:
            colorInput.hoveredpaddingLeft || colorInput.hoveredpadding || "4px",
          margin: colorInput.hoveredmargin || colorInput.margin || "0px",
          marginTop:
            colorInput.hoveredmarginTop || colorInput.hoveredmargin || "0px",
          marginRight:
            colorInput.hoveredmarginRight || colorInput.hoveredmargin || "0px",
          marginBottom:
            colorInput.hoveredmarginBottom || colorInput.hoveredmargin || "0px",
          marginLeft:
            colorInput.hoveredmarginLeft || colorInput.hoveredmargin || "10px",

          borderTop:
            colorInput.hoveredborderTop ||
            colorInput.hoveredborder ||
            colorInput.border ||
            "1px solid #000000",
          borderRight:
            colorInput.hoveredborderRight ||
            colorInput.hoveredborder ||
            colorInput.border ||
            "1px solid #000000",
          borderBottom:
            colorInput.hoveredborderBottom ||
            colorInput.hoveredborder ||
            colorInput.border ||
            "1px solid #000000",
          borderLeft:
            colorInput.hoveredborderLeft ||
            colorInput.hoveredborder ||
            colorInput.border ||
            "1px solid #000000",
          borderSapcing:
            colorInput.hoveredborderSpacing ||
            colorInput.borderSpacing ||
            "0px",
          borderCollapse:
            colorInput.hoveredborderCollapse ||
            colorInput.borderCollapse ||
            "0px",
          borderRadius:
            colorInput.hoveredborderRadius || colorInput.borderRadius || "0",
          outline: colorInput.hoveredoutline || colorInput.outline || "none",

          position:
            colorInput.hoveredposition || colorInput.position || "relative",
          top: colorInput.hoveredtop || colorInput.top || "auto",
          right: colorInput.hoveredright || colorInput.right || "auto",
          bottom: colorInput.hoveredbottom || colorInput.bottom || "auto",
          left: colorInput.hoveredleft || colorInput.left || "auto",
          zIndex: colorInput.hoveredzIndex || colorInput.zIndex || "auto",

          boxShadow:
            colorInput.hoveredboxShadow || colorInput.boxShadow || "none",
          opacity: colorInput.hoveredOpacity || colorInput.opacity || 1,
          display: colorInput.hovereddisplay || colorInput.display || "inline",

          cursor: colorInput.hoveredcursor || colorInput.cursor || "default",
          transform:
            colorInput.hoveredtransform || colorInput.transform || "none",
          transition:
            colorInput.hoveredtransition || colorInput.transition || "none",
        }
      : {};
  const activeStyles =
    isDivActive && colorInput.pseudoClass === "active"
      ? {
          // width: colorInput.activatedwidth || colorInput.width || "200px",
          // height: colorInput.activatedheight || colorInput.height || "auto",

          padding: colorInput.activatedpadding || colorInput.padding || "0",
          paddingTop:
            colorInput.activatedpaddingTop ||
            colorInput.activatedpadding ||
            "4px",
          paddingRight:
            colorInput.activatedpaddingRight ||
            colorInput.activatedpadding ||
            "4px",
          paddingBottom:
            colorInput.activatedpaddingBottom ||
            colorInput.activatedpadding ||
            "4px",
          paddingLeft:
            colorInput.activatedpaddingLeft ||
            colorInput.activatedpadding ||
            "4px",
          margin: colorInput.activatedmargin || colorInput.margin || "0px",
          marginTop:
            colorInput.activatedmarginTop ||
            colorInput.activatedmargin ||
            "0px",
          marginRight:
            colorInput.activatedmarginRight ||
            colorInput.activatedmargin ||
            "0px",
          marginBottom:
            colorInput.activatedmarginBottom ||
            colorInput.activatedmargin ||
            "0px",
          marginLeft:
            colorInput.activatedmarginLeft ||
            colorInput.activatedmargin ||
            "10px",

          borderTop:
            colorInput.activatedborderTop ||
            colorInput.activatedborder ||
            colorInput.border ||
            "1px solid #000000",
          borderRight:
            colorInput.activatedborderRight ||
            colorInput.activatedborder ||
            colorInput.border ||
            "1px solid #000000",
          borderBottom:
            colorInput.activatedborderBottom ||
            colorInput.activatedborder ||
            colorInput.border ||
            "1px solid #000000",
          borderLeft:
            colorInput.activatedborderLeft ||
            colorInput.activatedborder ||
            colorInput.border ||
            "1px solid #000000",
          borderSapcing:
            colorInput.activatedborderSpacing ||
            colorInput.borderSpacing ||
            "0px",
          borderCollapse:
            colorInput.activatedborderCollapse ||
            colorInput.borderCollapse ||
            "0px",
          borderRadius:
            colorInput.activatedborderRadius || colorInput.borderRadius || "0",
          outline: colorInput.activatedoutline || colorInput.outline || "none",

          position:
            colorInput.activatedposition || colorInput.position || "relative",
          top: colorInput.activatedtop || colorInput.top || "auto",
          right: colorInput.activatedright || colorInput.right || "auto",
          bottom: colorInput.activatedbottom || colorInput.bottom || "auto",
          left: colorInput.activatedleft || colorInput.left || "auto",
          zIndex: colorInput.activatedzIndex || colorInput.zIndex || "auto",

          boxShadow:
            colorInput.activatedboxShadow || colorInput.boxShadow || "none",
          opacity: colorInput.activatedOpacity || colorInput.opacity || 1,
          display:
            colorInput.activateddisplay || colorInput.display || "inline",
          cursor: colorInput.activatedcursor || colorInput.cursor || "default",
          transform:
            colorInput.activatedtransform || colorInput.transform || "none",
          transition:
            colorInput.activatedtransition || colorInput.transition || "none",
        }
      : {};

  const inputStyle = {
    width: colorInput.width || "60px",
    height: colorInput.height || "35px",

    margin: colorInput.margin || "0px",
    marginTop: colorInput.marginTop || colorInput.margin || "0",
    marginRight: colorInput.marginRight || colorInput.margin || "0px",
    marginBottom: colorInput.marginBottom || colorInput.margin || "0",
    marginLeft: colorInput.marginLeft || colorInput.margin || "10px",
    padding: colorInput.padding || "0",
    paddingTop: colorInput.paddingTop || colorInput.padding || "4px",
    paddingRight: colorInput.paddingRight || colorInput.padding || "4px",
    paddingBottom: colorInput.paddingBottom || colorInput.padding || "4px",
    paddingLeft: colorInput.paddingLeft || colorInput.padding || "4px",

    borderTop: isHovered
      ? "1px dashed #555"
      : colorInput.borderTop || colorInput.border || "1px solid #000000",
    borderRight: isHovered
      ? "1px dashed #555"
      : colorInput.borderRight || colorInput.border || "1px solid #000000",
    borderBottom: isHovered
      ? "1px dashed #555"
      : colorInput.borderBottom || colorInput.border || "1px solid #000000",
    borderLeft: isHovered
      ? "1px dashed #555"
      : colorInput.borderLeft || colorInput.border || "1px solid #000000",

    borderSapcing: colorInput.borderSpacing || "0px",
    borderCollapse: colorInput.borderCollapse || "0px",
    borderRadius: colorInput.borderRadius || "0",
    outline: colorInput.outline || "none",

    position: colorInput.position || "static",
    top: colorInput.top || "auto",
    right: colorInput.right || "auto",
    bottom: colorInput.bottom || "auto",
    left: colorInput.left || "auto",
    zIndex: colorInput.zIndex || "auto",

    opacity: colorInput.opacity || "1",
    display: colorInput.display || "inline-block",
    cursor: colorInput.cursor || "auto",

    transform: colorInput.transform || "none",
    transition: colorInput.transition || "none",

    scale: isHovered ? "1.01" : "1",
    ...hoverStyles,
    ...focusedStyles,
    ...activeStyles,
  };

  const labelStyle = {
    margin: colorInput.labelmargin || "0px",
    marginTop: colorInput.labelmarginTop || colorInput.labelmargin || "0",
    marginRight: colorInput.labelmarginRight || colorInput.labelmargin || "0px",
    marginBottom: colorInput.labelmarginBottom || colorInput.labelmargin || "0",
    marginLeft: colorInput.labelmarginLeft || colorInput.labelmargin || "0",
    padding: colorInput.labelpadding || "0px",
    paddingTop: colorInput.labelpaddingTop || colorInput.labelpadding || "0",
    paddingRight:
      colorInput.labelpaddingRight || colorInput.labelpadding || "0",
    paddingBottom:
      colorInput.labelpaddingBottom || colorInput.labelpadding || "0",
    paddingLeft: colorInput.labelpaddingLeft || colorInput.labelpadding || "0",

    borderTop: isHovered
      ? "1px dashed #555"
      : colorInput.labelborderTop || colorInput.labelborder || "none",
    borderRight: isHovered
      ? "1px dashed #555"
      : colorInput.labelborderRight || colorInput.labelborder || "none",
    borderBottom: isHovered
      ? "1px dashed #555"
      : colorInput.labelborderBottom || colorInput.labelborder || "none",
    borderLeft: isHovered
      ? "1px dashed #555"
      : colorInput.labelborderLeft || colorInput.labelborder || "none",

    borderSapcing: colorInput.labelborderSpacing || "0px",
    borderCollapse: colorInput.labelborderCollapse || "0px",
    borderRadius: colorInput.labelborderRadius || "0",
    outline: colorInput.labeloutline || "none",

    position: colorInput.labelposition || "static",
    top: colorInput.labeltop || "auto",
    right: colorInput.labelright || "auto",
    bottom: colorInput.labelbottom || "auto",
    left: colorInput.labelleft || "auto",
    zIndex: colorInput.labelzIndex || "auto",

    color: colorInput.labelcolor || "#000000",
    backgroundColor: colorInput.labelbackgroundColor || "#ffffff",
    backgroundImage: backgroundImagelabelUrl
      ? `url(${backgroundImagelabelUrl})`
      : labelconstructGradientString(),
    backgroundPosition:
      colorInput.labelbackgroundPosition ||
      colorInput.labelbackgroundPosition ||
      "0% 0%",
    backgroundSize:
      colorInput.labelbackgroundSize ||
      colorInput.labelbackgroundSize ||
      "auto",
    backgroundRepeat:
      colorInput.labelbackgroundRepeat ||
      colorInput.labelbackgroundRepeat ||
      "repeat",
    backgroundAttachment:
      colorInput.labelbackgroundAttachment ||
      colorInput.labelbackgroundAttachment ||
      "scroll",

    fontSize: colorInput.labelfontSize || "inherit",
    fontFamily: colorInput.labelfontFamily || "inherit",
    fontWeight: colorInput.labelfontWeight || "normal",
    fontStyle: colorInput.labelfontStyle || "normal",
    fontVariant: colorInput.labelfontVariant || "normal",
    lineHeight: colorInput.labellineHeight || "normal",
    textAlign: colorInput.labeltextAlign || "left",
    textDecoration: colorInput.labeltextDecoration || "none",
    textTransform: colorInput.labeltextTransform || "none",
    textShadow: colorInput.labeltextShadow || "none",
    verticalAlign: colorInput.labelverticalAlign || "baseline",
    letterSpacing: colorInput.labelletterSpacing || "normal",
    wordSpacing: colorInput.labelwordSpacing || "normal",
    textIndent: colorInput.labeltextIndent || "0",
    whiteSpace: colorInput.labelwhiteSpace || "normal",
    textOverflow: colorInput.labeltextOverflow || "clip",
    direction: colorInput.labeldirection || "ltr",
    unicodeBidi: colorInput.labelunicodeBidi || "normal",
    writingMode: colorInput.labelwritingMode || "horizontal-tb",

    opacity: colorInput.labelopacity || "1",
    display: colorInput.display || "inline-flex",
    cursor: colorInput.cursor || "auto",

    transform: colorInput.transform || "none",
    transition: colorInput.transition || "none",
  };

  return (
    <>
      <label style={labelStyle}>{colorInput.label || "Color"}</label>

      <input
        type="color"
        value={colorInput.value}
        style={inputStyle}
        onMouseEnter={() => setIsDivHovered(true)}
        onMouseLeave={() => setIsDivHovered(false)}
        onFocus={() => setIsDivFocused(true)}
        onBlur={() => setIsDivFocused(false)}
        onMouseDown={() => setIsDivActive(true)}
        onMouseUp={() => setIsDivActive(false)}
      />
    </>
  );
};

export default ColorInputComponent;
